module.exports = __webpack_public_path__ + "img/GL.826f4a58.png";